/* eslint-disable */
// import lib(s)
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './IdtfEOSReview.css';
import ContentHeader from 'legacy/containers/ContentHeader';
import {
  fetchEOSHtml,
  getEOSJsonData,
  fetchEOSHtmlReverseProxy,
  esignEOSPdfs,
} from 'legacy/containers/ApiUrls';
import { getPhysicianName } from '../../../legacy/containers/Utilities/';
import { notification } from 'antd';
import moment from 'moment';
import { updateSelectedTab } from 'state/reducers/patient/patientActions';
import { createRoute } from 'routes/patientRouteUtils';
// import { PATIENT_FILE_TABS } from '../../pages/PatientFile/PatientFileUtils';
import { PATIENT_FILE_TABS } from '../../pages/PatientFile/PatientFileUtils';
import EcgLoader from 'legacy/containers/EcgLoader';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import CloseIcon from '@material-ui/icons/Close';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));



const IdtfEOSReview = props => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const me = useSelector(state => state.app.dataSources.me);
  const EOSPage = useRef();
  const EOSPageHeight =
    document.body.scrollHeight - 150 > 800
      ? document.body.scrollHeight - 150
      : 800;
  const eos_id = props.match.params.eos_id;
  const participant_id = props.match.params.participantId;
  const [EOSData, setEOSData] = useState({ message: 'Initial State' });
  const [EOSHTML, setEOSHTML] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [errorState, setErrorState] = useState(false);
  const [Interp, setInterp] = useState('');
  const [Esign, setEsign] = useState(false);
  const [DisableForm, setDisableForm] = useState(true);
  const [ShowSignedByMessage, setShowSignedByMessage] = useState(false)
  const [Signature, setSignature] = useState("")
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVarient, setAlertVarient] = useState("");
  //   const EOS_LIVE ='https://pdf-service-k8s.us-staging.alivecor.com/pdf/eos/live-update';
  //   const EOS_LIVE ='http://localhost:8000/pdf/eos/live-update';
  // console.log(props);

  let physicianName = '';
  if (me.data) {
    physicianName = getPhysicianName(
      me.data.profile.firstName,
      me.data.profile.lastName,
      '',
    );
  }
  
  useEffect(() => {
    // console.log(eos_id);
    // Fetching JSON data for the EOS
    dispatch(getEOSJsonData(eos_id))
      .then(res1 => {
        // console.log('EOS JSON Data Fetched');
        // console.log(res1);
        setEOSData(res1);
        const { e_sign } = res1;
        let signed_at = '';
        let signed_by = '';
        let signing_note = '';
        if (e_sign) {
          signed_at = e_sign.signed_at ? `at ${moment(new Date(e_sign.signed_at)).format('MM-DD-YYYY hh:mmA z')}` : '';
          signed_by = e_sign.signed_by ? e_sign.signed_by : '';
          signing_note = e_sign.signing_note ? e_sign.signing_note : '';
          if (signed_by) {
            setEsign(true);
            setDisableForm(true);
            setShowSignedByMessage(true);
            setSignature(`${signed_by} ${signed_at}`)
          }
          setInterp(signing_note);
        }
        // Using the JSON Data to Generate EOS Html
        // dispatch(fetchEOSHtmlReverseProxy(res,eos_id)).then(res => {
        dispatch(
          fetchEOSHtmlReverseProxy(
            {
              signed_at: new Date('10/10/2004'),
              signed_by: 'me',
              signing_note: 'signing note',
            },
            eos_id,
          ),
        )
          .then(res => {
            if (res.status === 200) {
              // console.log('Status 200');
              res.text().then(html => {
                // console.log('Page html received');
                setLoading(false);
                setErrorState(false);
                html = html.replace(
                  '<head>',
                  `<head><link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
            `,
                );
                html = html.replace(
                  /<p id=\"esign-note\">(.*?)<\/p>/g,
                  `<p id="esign-note">${signing_note}</p>`,
                );
                html = html.replace(
                  /<p id=\"esign-signature\">(.*?)<\/p>/g,
                  `<p id="esign-signature">${signed_by} ${signed_at}</p>`,
                );
                if (!signed_by) setDisableForm(false);
                setEOSHTML(html);
              });
            } else {
              // console.log('Page Errored', res);
              let errorMessage = res.statusText;
              setError(errorMessage);
              res.json().then(err => {
                setError(err.message ? err.message : err);
                // notification['error']({
                //   description: 'Error fetching the page',
                // });
                setAlertOpen(true)
                setAlertVarient("error")
                setAlertMessage(`Error fetching the page, Please try again.`)
              });
              setLoading(false);
              setErrorState(true);
            }
          })
          .catch(e => {
            // console.log('Page Errored', e);
            setError(e);
            setLoading(false);
            setErrorState(true);
            // notification['error']({ description: e });
            setAlertOpen(true)
            setAlertVarient("error")
            setAlertMessage(`System Error, Please try again.`)
          });
      })
      .catch(e => {
        // console.log('Page Errored', e);
        setError(e);
        setLoading(false);
        setErrorState(true);
      });
  }, []);

  useEffect(() => {
    if(alertOpen) {
      window.setTimeout(()=>setAlertOpen(false),6000)
    }
  }, [alertOpen])

  const handleInterpretationChange = e => {
    e.preventDefault();
    EOSPage.current.contentDocument.getElementById('esign-note').innerHTML =
      e.target.value.replace(/\n/g,'<br />');
    setInterp(e.target.value);
  };

  const handleEsignChange = () => {
    setEsign(!Esign);
    if (!Esign) {
      EOSPage.current.contentDocument.getElementById('esign-signature').innerHTML = `${physicianName} at ${moment(new Date()).format('MM-DD-YYYY hh:mmA z')}`;
    } else {
      EOSPage.current.contentDocument.getElementById('esign-signature').innerHTML = ``;
    }
  };

  const submitForm = e => {
    e.preventDefault();
    // console.log('Submitted =>', Interp, ' | ', Esign);
    setLoading(true)
    setDisableForm(true);
    let html = EOSHTML;
    const EOSSig = EOSPage.current.contentDocument.getElementById('esign-signature').innerHTML
    const EOSNote = EOSPage.current.contentDocument.getElementById('esign-note').innerHTML
    html = html.replace(
      /<p id=\"esign-note\">(.*?)<\/p>/g,
      `<p id="esign-note">${EOSNote}</p>`,
    );
    html = html.replace(
      /<p id=\"esign-signature\">(.*?)<\/p>/g,
      `<p id="esign-signature">${EOSSig}</p>`,
    );
    setEOSHTML(html);
    dispatch(esignEOSPdfs({ signing_note: Interp, is_signed: Esign }, eos_id))
      .then(res => {
        if (res.status === 200) {
          // console.log('Status 200');
          res.json().then(res => {
            // console.log('E-Sign Success');
            // notification['success']({ description: res.message });
            setAlertOpen(true)
            if(Esign) {
              setShowSignedByMessage(true);
              setSignature(EOSSig);
              setAlertVarient("success")
              setAlertMessage(`Success! This report was E-signed by ${EOSSig}`)
            } else {
              setDisableForm(false);
              setAlertVarient("success")
              setAlertMessage("Success! An interpretation has been saved.")
            }
          });
        } else {
          // console.log('Page Errored', res);
          let errMssg = res.statusText;
          res.json().then(err => {
            setAlertOpen(true)
            setAlertVarient("error")
            setAlertMessage(`System Error, Please try again.`)
            // notification['error']({ description: err.errors[0].detail });
          });
          // console.log('e-sign failed: ', errMssg);
        }
      })
      .catch(e => {
        // console.log('Page Errored', e);
        setAlertOpen(true)
        setAlertVarient("error")
        setAlertMessage(`System Error, Please try again.`)
        // notification['error']({ description: e });
      }).finally(() => {
        setLoading(false)
      });
  };

  const handleCancel = () => {
    const { history } = props;
    dispatch(updateSelectedTab(PATIENT_FILE_TABS.KARDIA_RX));
    history.push(
      createRoute({
        patientId: participant_id || EOSData.patient.participant_id,
        kardiaRxEcg: 'patientSearch',
        idtf_connection_id: eos_id,
      }),
    );
  };
  return (
    <React.Fragment>
      <div data-page="IdtfEOSReview" className={styles.IdtfEOSReviewPage}>
        <ContentHeader
          isLoading={me.isFetching}
          showLastRefresh={false}
          text="EOS Review"
          me={me}
          showAddPatient={false}
          enableBackButton={true}
          isFullWidth={true}
        />

        <div className={classes.root}>
          <Collapse in={alertOpen}>
            <Alert
              variant="filled"
              severity={alertVarient}
              action={
                <ButtonGroup>
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      handleCancel();
                    }}
                  >
                    <ArrowBackIcon fontSize="inherit" />
                  </IconButton>
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setAlertOpen(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                </ButtonGroup>
              }
            >
            {alertMessage}
            </Alert>
          </Collapse>
        </div>
        <div className={styles.container} style={{ height: EOSPageHeight }}>
          {/* <div
            className={styles.page}
            dangerouslySetInnerHTML={{ __html: loading ? "Loading ..." : (errorState ? error : EOSHTML) }}
          ></div> */}
          <div className={styles.page}>
            {loading ?
              <EcgLoader />
            :
              <iframe
                ref={EOSPage}
                style={{ height: '100%', width: '100%' }}
                srcDoc={loading ? 'Loading ...' : errorState ? error : EOSHTML}
              />
            }
          </div>
          <div className={styles.options}>
            <div className={styles.providerInterpretation}>
              Provider Interpretation
              <textarea
                disabled={DisableForm}
                value={Interp}
                onChange={handleInterpretationChange}
                className={styles.providerInterpretationTextarea}
              ></textarea>
            </div>
            <div className={styles.esignSelectArea}>
              <div className={styles.esignCheckBox}>
                <input
                  disabled={DisableForm}
                  checked={Esign}
                  onChange={handleEsignChange}
                  className={styles.esignCheckBoxInput}
                  type="checkbox"
                />
              </div>
              <div className={styles.esignTextSection}>
                <div className={styles.esignTextHeader}>E-SIGN</div>
                <div className={styles.esignText}>
                  Once signed, additional edits will not be allowed.
                </div>
              </div>
            </div>

            <div className={styles.buttonSection}>
              <button
                type="button"
                onClick={handleCancel}
                className={styles.leftButton}
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={DisableForm}
                onClick={submitForm}
                className={styles.rightButton}
              >
                Save
              </button>
            </div>
            {ShowSignedByMessage && (
              <div className={styles.disabledText}>
                This report was E-signed by <br />
                <span>{Signature}</span>
              </div>
            )}
            {/*             
            <hr style={{margin:"unset",marginBottom:"20px"}}/>
            <center>=== Debugger ===</center>
            <center>{eos_id}</center>
            Loading: {`${loading}`}<br/>
            errorMessage: {`${error}`}<br/>
            errorState: {`${errorState}`}<br/>
            <div style={{width:"100%",display:"flex",textAlign:"center"}}>
              <span style={{backgroundColor: EOSData.message == "Initial State" ? "red" : "green",color:"white",padding:"10px",width:"50%"}}>JSON</span>
              <span style={{backgroundColor: EOSHTML == "" ? "red" : "green" ,color:"white",padding:"10px",width:"50%"}}>HTML</span>
            </div>
            
            <a style={{textAlign:"center",margin:'10px'}} href={`data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(EOSData))}`} download={`${eos_id}.json`} >
              Download EOS JSON
            </a> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default IdtfEOSReview;



// WEBPACK FOOTER //
// ./src/views/pages/IdtfEOSReview/IdtfEOSReview.jsx